import React, { useState } from 'react';
import { CountUp } from 'use-count-up';
import axios from 'axios';
import Modal from 'react-modal';
import { If, Then } from 'react-if';

function StakingSection({ refreshPage, address, profitData, userInfo, creta, userMatic, setStakingModalOpen, setStakingListModalOpen, data}) {    
 
    const setShowStakingModal  = ()=>{
        setStakingModalOpen(true);
    }
    const setShowStakingListModal  = ()=>{
        setStakingListModalOpen(true);
    }

    const CountUpValue = (amount) => {
        if(amount === undefined || amount === 0 || amount === null){
            return <CountUp end={0} thousandsSeparator=","/>
        } else {
            return <CountUp isCounting start={0} end={amount} thousandsSeparator=","/>
        }
    }
    
    return(   
        <div className="mining-wrap">
            <div className="profit-title">Staking</div>
            <div className="profit-wrap">
                <div className="profit-header">
                    <p className="profit-name">Total staking amount </p>
                    <span className="profit-data profit-data-flxd">{CountUpValue(userInfo.total_staking_amount)}</span>
                </div>               
                <div className="profit-header">
                    <p className="profit-name">Total staking interest </p>
                    <span className="profit-data profit-data-flxd">{CountUpValue(userInfo.total_staking_interest)}</span>
                </div>   
                <div className="flex-space-between">
                    <div></div>                    
                </div>
                <hr />
                <div className="flex-space-between">                    
                    <button className="btn btn-secondary btn-shadow btn-md mr-2" onClick={() => setShowStakingListModal(true)}>Detail</button>  
                    {/* <button className="btn btn-primary btn-shadow btn-md " onClick={() => setShowStakingModal(true)}>Staking</button> */}
                </div>
           
            </div>
        </div>  
    );
   
}

export default StakingSection;